import { render, staticRenderFns } from "./pls_sss_yc.vue?vue&type=template&id=29b3daa0&scoped=true"
import script from "./pls_sss_yc.vue?vue&type=script&lang=js"
export * from "./pls_sss_yc.vue?vue&type=script&lang=js"
import style0 from "./pls_sss_yc.vue?vue&type=style&index=0&id=29b3daa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3daa0",
  null
  
)

export default component.exports